var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "ykd-back_to_top",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "//qiniu-cdn7.jinxidao.com/m/images/goToTop.png"
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };